export default [{"trem":4.58, "cons":0.5, "depr":0.43, "fati":0.38, "dizz":0.15, 
"urin":0.52, "bala":1.39, "memo":0.34, "hypo":0.46, "rigi":2.49, "cogn":1, "hype":1.99, "exsm":-0.33, "curr":-0.86,
"m50":-6.64, "m60": -5.85, "m70":-5.32, "m80":-5.06, "m90": -4.87,
"f50":-7.65, "f60": -6.54, "f70":-5.7, "f80":-5.51, "f90": -5.81, 
}];


